<template>
    <div class="admin-container">
        <div class="admin-header">
            <h2>订单管理</h2>
        </div>

        <div class="admin-content">
            <!-- 筛选条件 -->
            <div class="filter-section">
                <van-button type="primary" @click="exportCSV">导出CSV</van-button>
            </div>

            <!-- 订单列表 -->
            <div class="order-list">
                <table>
                    <thead>
                        <tr>
                            <th>订单号</th>
                            <th>套餐</th>
                            <th>收件人</th>
                            <th>联系电话</th>
                            <th>地址</th>
                            <th>下单时间</th>
                            <th>班组</th>
                            <th>登录员工姓名</th>
                            <th>送货日期</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="order in orders" :key="order.id">
                            <td>{{ order.id }}</td>
                            <td>{{ order.package }}</td>
                            <td>{{ order.recipient }}</td>
                            <td>{{ order.mobile }}</td>
                            <td class="address-cell">{{ order.address }}</td>
                            <td>{{ order.created_at }}</td>
                            <td>{{ order.class || '-' }}</td>
                            <td>{{ order.staff?.name || '-' }}</td>
                            <td>{{ order.sendDate || '-' }}</td>
                        </tr>
                        <tr v-if="orders.length === 0">
                            <td colspan="9" class="empty">暂无订单</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 分页 -->
            <!-- <div class="pagination">
                <van-pagination v-model="currentPage" :total-items="totalItems" :items-per-page="pageSize"
                    @change="onPageChange" />

            </div> -->
        </div>
    </div>
</template>

<script>
import Api from '@/Utils';
import { showFailToast } from 'vant';


export default {
    name: 'AdminPage',
    props: {
        msg: String
    },
    components: {

    },
    data() {
        return {
            minDate: new Date(2026, 0, 1),
            maxDate: new Date(),
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            orders: [],
        };
    },
    computed: {
        paginatedOrders() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.orders.slice(start, end);
        }
    },
    mounted() {
        this.generateMockData();
    },
    methods: {
        async generateMockData() {

            let orders = [];
            const response = await Api.get('/api/order/list');
            let resp = await response.json();
            if (resp.code === 20000) {
                orders = resp.data.items;
            } else {
                showFailToast(resp.message || '获取订单列表失败')
            }

            this.orders = orders;
            this.totalItems = orders.length;
        },


        onPageChange(page) {
            this.currentPage = page;
        },
        exportCSV() {
            // 生成CSV内容
            const headers = ['订单号', '套餐', '收件人', '联系电话', '地址', '下单时间', '班组', '登录员工姓名', '送货日期'];
            const rows = this.orders.map(order => [
                order.id,
                order.package,
                order.recipient,
                order.mobile,
                order.address,
                order.created_at,
                order.class || '-',
                order.staff?.name || '-',
                order.sendDate || '-'
            ]);

            // 组合CSV数据
            const csvContent = [
                headers.join(','),
                ...rows.map(row => row.join(','))
            ].join('\n');

            // 添加BOM标记以解决乱码问题
            const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });

            // 创建下载链接
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `订单数据_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
</script>

<style scoped>
.admin-container {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.admin-header {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-header h2 {
    margin: 0;
    color: #333;
}

.admin-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-section {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.order-list {
    margin-bottom: 20px;
    overflow-x: auto;
}

.order-list table {
    width: 100%;
    border-collapse: collapse;
}

.order-list th,
.order-list td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e8e8e8;
}

.order-list th {
    background-color: #f5f5f5;
    font-weight: 600;
}

.order-list .empty {
    text-align: center;
    padding: 40px;
    color: #999;
}

.order-list .address-cell {
    max-width: 200px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>